import { Button, Typography } from '@cannect/new-components/atoms'
import { ProductListItem } from '@cannect/new-components/organisms/ProductListItem'
import { useTokenApi } from 'hooks/useTokenApi'
import { CirclePlus } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { toast } from 'react-toastify'
import api from 'services/api'
import * as Styles from './styles'

export interface RelatedProductProps {
  filters?: string
  limit?: number
  titleSection?: string
}

export default function RelatedProduct({ filters, titleSection, limit }: RelatedProductProps) {
  const [loading, setLoading] = useState(false)
  const [productItems, setProductItems] = useState<any[]>([])
  const { tokenApi } = useTokenApi()
  const { id } = useParams() as any
  const history = useHistory()
  const urlAuth = tokenApi
    ? `list-products?page=1&${filters}&limit=${limit || 6}`
    : `list-products-public?page=1&${filters}&limit=${limit || 6}`

  const getRelatedProduct = async () => {
    setLoading(true)
    try {
      const { data } = await api.get(urlAuth)
      if (data?.success) {
        const validateProduct = data?.products?.rows?.filter((item: any) => `${id}` !== `${item.id}`)
        setProductItems(validateProduct)
      }
    } catch (e) {
      toast.error('Erro ao buscar produtos relacionados')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (filters) {
      getRelatedProduct()
    }
  }, [filters])

  const handleViewAll = () => {
    history.push(`/produtos/1?${filters}`)
  }

  const getProductImage = (product: any) => {
    const productImage = product?.media?.find((m: any) => m.format === 'IMG')?.path
    return productImage || '/src/assets/img/default-product.png'
  }

  if (!loading && productItems.length === 0) {
    return null
  }

  return (
    <Styles.Wrapper>
      <section className="py-12">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center">
            <Typography.Heading type="headingFour" weight="regular" className="text-2xl font-normal">
              {titleSection || 'Produtos semelhantes'}
            </Typography.Heading>
          </div>
          <Button
            unstyled
            icon={<CirclePlus size={20} />}
            iconPlacement="left"
            onClick={handleViewAll}
            className="gap-2 font-medium text-primary-800">
            Ver todos
          </Button>
        </div>

        {loading && (
          <div className="flex h-32 items-center justify-center">
            <Typography.Text muted>Carregando produtos...</Typography.Text>
          </div>
        )}

        {!loading && productItems.length > 0 && (
          <div className="flex gap-6 overflow-x-auto pb-4">
            {productItems.map((product) => (
              <div key={product.id} className="flex-shrink-0">
                <ProductListItem
                  product={{
                    ...product,
                    image: getProductImage(product)
                  }}
                  variant="grid"
                  isLargeCard
                />
              </div>
            ))}
          </div>
        )}
      </section>
    </Styles.Wrapper>
  )
}
